const NotFound = () => {
	return (
		<div>
			<h3>Opps</h3>
		</div>
	);
};

export default NotFound;
